import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles((theme) => ({
    loyalitybox:{
        "&.MuiGrid-root":{
            // backgroundColor:"red",
            borderRadius:"5px",
            height:"70vh",
            display:"flex",
            alignItems:"center"
        }
    }
}))